module.exports = __webpack_public_path__ + "static/markus-e37602ef87e2d79abaa7a7d00c6eb225.png";